module.exports = __webpack_public_path__ + "img/jifen2.736f351c.png";